import { textUtils } from '@instinet-analytics/core-lib';
import { AggregationField } from '../fields/aggregationFieldPortfolio';
import {
    PortfolioSummaryAggregatedData,
    initialiseGroup,
} from 'widgets/portfolioSummary/store/data/PortfolioSummaryDataState';
import { PortfolioItem } from 'portfolio/PortfolioItem';
import {
    AggregationStrategy,
    PortfolioSummarySortableDataItem,
} from './AggregationStrategy';

const { isFalsyOrWhitespace } = textUtils;

/*
 * Default aggregation strategy for fields other that "side" or enum maps
 */
export class DefaultAggregationStrategy implements AggregationStrategy {
    public constructor(
        public aggregationField: AggregationField,
        public combineSellsAndShorts: boolean
    ) {}

    public initialiseAggregatedData() {
        return {};
    }

    public getAggregationGroup(
        data: PortfolioSummaryAggregatedData,
        item: PortfolioItem
    ) {
        const portfolioItemField = this.aggregationField;
        const fieldValue = (
            isFalsyOrWhitespace(item[portfolioItemField]?.toString())
                ? 'N/A'
                : item[portfolioItemField]!.toString()
        ).toString();
        if (!data[fieldValue]) {
            data[fieldValue] = initialiseGroup(
                fieldValue,
                this.combineSellsAndShorts
            );
        }
        if (isFalsyOrWhitespace(item[portfolioItemField]?.toString())) {
            data[fieldValue].total.selectionDisabled = true;
        }
        return data[fieldValue];
    }

    public filterPortfolio(
        filteredPortfolio: PortfolioItem[],
        groupName: string
    ): PortfolioItem[] {
        return filteredPortfolio.filter(
            (item) => item[this.aggregationField] === groupName
        );
    }

    public getDrillDowns(
        data: PortfolioSummaryAggregatedData,
        item: PortfolioItem
    ) {
        return this.getAggregationGroup(data, item).drillDowns;
    }

    public sort(
        x: PortfolioSummarySortableDataItem,
        y: PortfolioSummarySortableDataItem
    ): number {
        return y.orderedValueLoc - x.orderedValueLoc;
    }

    public groupNameToValue(groupName: string): string {
        return groupName;
    }
}
